import { lazy } from "react";
import { useRoutes } from "react-router-dom";
import ProtectedRoutes from "routes/ProtectedRoutes";
import RedirectTo from "routes/RedirectTo";
import { TerminalType_Enum } from "services/sale/common/enums";
import PassengerCurrentTripStoreProvider from "./passenger/PassengerCurrentTripStoreProvider";
import {
  Base_Url_Route,
  Index_Route,
  Login_Route,
  MP_AddCredit_Route,
  MP_CheckTripAccess_Route,
  MP_CompleteRegister_Route,
  MP_Error_Route,
  MP_Loading_Route,
  MP_MessageDetial_Route,
  MP_Message_Route,
  MP_PassengerReservedSales_Route,
  MP_Profile_Route,
  MP_SplashScreen_Route,
  MP_TripSecurity_Route,
  MP_WalletReceipt_Route,
  MP_WalletTransactions_Route,
  MP_Wallet_Route,
} from "./routesVar";

const MarketPlaceLayout = lazy(() =>
  import("shared/marketPlace/fleet").then((module) => ({
    default: module.Layout,
  }))
);

const Home = lazy(() =>
  import("pages/home").then((module) => ({
    default: module.Home,
  }))
);

const PassengerLogin = lazy(() =>
  import("shared-components/login/passengerLogin").then((module) => ({
    default: module.PassengerLogin,
  }))
);
const Profile = lazy(() =>
  import("pages/passenger/profile").then((module) => ({
    default: module.Profile,
  }))
);
const NotFound = lazy(() =>
  import("shared-components/notFound").then((module) => ({
    default: module.NotFound,
  }))
);

const CompleteRegister = lazy(() =>
  import("pages/passenger/completeRegister").then((module) => ({
    default: module.CompleteRegister,
  }))
);

const Messages = lazy(() =>
  import("pages/passenger/message/messages/view").then((module) => ({
    default: module.Messages,
  }))
);

const MessageDetail = lazy(() =>
  import("pages/passenger/message/messageDetail/view").then((module) => ({
    default: module.MessageDetail,
  }))
);

const LoadingPage = lazy(() =>
  import("pages/passenger/loadingPage/view").then((module) => ({
    default: module.LoadingPage,
  }))
);
const LanguageSplashScreen = lazy(() =>
  import("pages/passenger/common/languageSplashScreen").then((module) => ({
    default: module.LanguageSplashScreen,
  }))
);

const Error = lazy(() =>
  import("pages/passenger/common/error/view").then((module) => ({
    default: module.Error,
  }))
);

const TripSecurity = lazy(() =>
  import("pages/passenger/tripSecurity").then((module) => ({
    default: module.TripSecurity,
  }))
);
const CheckTripAccess = lazy(() =>
  import("pages/passenger/checkTripAccess").then((module) => ({
    default: module.CheckTripAccess,
  }))
);
const PassengerReservedSales = lazy(() =>
  import("pages/passenger/reservedSales").then((module) => ({
    default: module.PassengerReservedSales,
  }))
);
const PassengerWalletLayout = lazy(() =>
  import("pages/passenger/wallet/layout").then((module) => ({
    default: module.PassengerWalletLayout,
  }))
);

const Transactions = lazy(() =>
  import("pages/passenger/wallet/transactions").then((module) => ({
    default: module.Transactions,
  }))
);
const PassengerWallet = lazy(() =>
  import("pages/passenger/wallet").then((module) => ({
    default: module.PassengerWallet,
  }))
);
const WalletReceipt = lazy(() =>
  import("pages/passenger/wallet/receipt").then((module) => ({
    default: module.WalletReceipt,
  }))
);

const AddCredit = lazy(() =>
  import("pages/passenger/wallet/addCredit").then((module) => ({
    default: module.AddCredit,
  }))
);
export const MPRoutes = () =>
  useRoutes([
    { path: Index_Route, element: <RedirectTo /> },
    {
      element: <TripSecurity />,
      path: MP_TripSecurity_Route,
    },
    {
      children: [
        {
          element: <PassengerCurrentTripStoreProvider />,
          children: [
            {
              element: (
                <PassengerLogin paltformType={TerminalType_Enum.PassengerApp} />
              ),
              path: Login_Route,
            },

            {
              element: <ProtectedRoutes returnUrl />,
              children: [
                {
                  element: <MarketPlaceLayout />,
                  children: [
                    {
                      path: Base_Url_Route,
                      element: <Home />,
                    },
                  ],
                },
                {
                  element: <PassengerReservedSales />,
                  path: MP_PassengerReservedSales_Route,
                },
                {
                  element: <PassengerWalletLayout />,
                  children: [
                    {
                      path: MP_Wallet_Route,
                      element: <PassengerWallet />,
                    },
                    {
                      path: MP_WalletTransactions_Route,
                      element: <Transactions />,
                    },
                    {
                      path: MP_AddCredit_Route,
                      element: <AddCredit />,
                    },
                    {
                      path: MP_WalletReceipt_Route,
                      element: <WalletReceipt />,
                    },
                  ],
                },
                {
                  element: <Profile />,
                  path: MP_Profile_Route,
                },
                {
                  element: <CompleteRegister />,
                  path: MP_CompleteRegister_Route,
                },
                {
                  element: <Messages />,
                  path: MP_Message_Route,
                },
                {
                  element: <MessageDetail />,
                  path: MP_MessageDetial_Route,
                },
              ],
            },
          ],
        },
        {
          element: <ProtectedRoutes returnUrl />,
          children: [
            {
              element: <CheckTripAccess />,
              path: MP_CheckTripAccess_Route,
            },
          ],
        },

        {
          element: <LoadingPage />,
          path: MP_Loading_Route,
        },
        {
          element: <Error />,
          path: MP_Error_Route,
        },
        {
          element: <LanguageSplashScreen />,
          path: MP_SplashScreen_Route,
        },
        {
          element: <></>,
          path: "*",
        },
      ],
    },
  ]);
